/*
 * @Author: w
 * @Date: 2022-04-11 11:36:23
 * @LastEditors: w
 * @LastEditTime: 2022-07-29 14:51:59
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useInfoStoreHook } from '@/stores/modules/login'
import { isEmptyValue } from '@/scripts/utils';
import {asyncRoutes} from './asyncRoutes'
import getHostData from '@/scripts/hostData'
import {getToken,getReFreshToken, setToken, setRefreshToken} from "@/scripts/token";
import { ElMessage } from 'element-plus'
import { storeToRefs } from 'pinia'
const userStore:any = useInfoStoreHook()
const whiteList: Array<RouteRecordRaw> = [
  {
    path: '/error',
    component: () => import(/* webpackChunkName: "error" */ '@/views/error/error.vue'),
    name: 'error',
    meta:{
      title:'出错了!'
    },
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "error404" */ '@/views/error/404.vue'),
    name: '404',
    meta:{
      title:'没找到相应页面'
    },
  },
  {
    path: '/ykindex',
    component: () => import(/* webpackChunkName: "yk" */ '@/views/error/yk.vue'),
    name: 'ykindex',
    meta:{
      title:'首页',
      requiresAuth: false
    },
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    name: 'login',
    meta:{
      title:'登录',
      requiresAuth: false
    },
  },
  {
    path: '/aiFullyManagedConfig',
    name: 'aiFullyManagedConfig',
    meta: {
      title: 'AI执行情况',
      isMenu: false,
    },
    component: () => import(/*webpackChunkName:"aiFullyManagedConfig"*/ '@/views/fpaManagement/aiFullyManaged/configAi.vue'),
  },
  {
    path: '/hscodetools',
    name: 'hscodetools',
    meta: {
      title: '归类助手',
      isMenu: false,
    },
    component: () => import(/*webpackChunkName:"hscodetools"*/ '@/views/intelligentClassifiyComponents/content.vue'),
  },
  {
    path: '/aiStatistics',
    name: 'aiStatistics',
    meta: {
      title: '统计',
      isMenu: false,
    },
    component: () => import(/*webpackChunkName:"aiStatistics"*/ '@/views/fpaManagement/aiFullyManaged/aiStatistics.vue'),
  },
  {
    path: '/bussinessQuestion',
    name: 'bussinessQuestion',
    meta: {
      title: '企业调查表',
    },
    component: () => import(/*webpackChunkName:"bussinessQuestion"*/ '@/views/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/businessQuestionnaire/detail.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes:[
    ...whiteList,
    ...asyncRoutes,
  ]
})

// 设置网页名字

let pageData = getHostData()

const setTitle = (titleName:string) => {
  window.document.title = `${pageData.title}-${titleName}`
}
let count = 0


function findItemByHref(menuArray: any, targetHref: string): boolean {
  function traverse(items: any[]): boolean {
    return items.some((item) => {
      if (item.href === targetHref) {
        return true;
      }
      if (item.childs) {
        return traverse(item.childs); 
      }
      return false;
    });
  }
  return traverse(menuArray);
}

router.beforeEach(async(to:any,from,next:Function,) => {
  let { menuList } = storeToRefs(userStore)
  const companyType = sessionStorage.getItem('companyType')
  if (companyType == 'yc') {
    if (to.name === 'tradeloanAmountApplication' || to.name === 'home') {
      next({  path: '/finance/authorizationManagement/psbc/e'})
    } else {
      const noAuth = findItemByHref(menuList.value, `${to.path}?type=test`)
      if (noAuth) {
        next({ path: '/finance/noAuthFinance/noAuthFinanceIndex'})
      }
    }
  }
  const token = getToken()
  const reFreshToken = getReFreshToken()
  if (userStore.assignAccountData && userStore.assignAccountData?.aiPage == 2) {
    if (to.name == 'home' || to.path == '/') {
      await userStore.asssignAccount()
      const routerParams:any = userStore.assignAccountData
      if (userStore?.assignAccountData?.type == 'backend') {
        next({path: '/fpaManagement/aiFullyManaged/index'})
      }
      else {
        next({path: '/aiFullyManagedConfig', query: {id: routerParams?.cid}})
      }
    }
    else {
      next()
    }
  }
  // 登录不管
  if (to.name === 'login' || to.name === 'ykindex') {
    next()
  } else if (!token && !reFreshToken) {
    // 无 token 且 已过期
    ElMessage.warning({
      message:'用户未登录',
      duration:4000
    })
    window.location.replace('/login?typeName=login')
    return
  } else if (userStore.menuList.length === 0) {
    // 有 token 且 没过期 获取路由表
    await userStore.getMenuAndCurrentCompany()
  }
  var path = to.path
  setTitle(to.meta.title)
  if (isEmptyValue(path) ) {
    return next('/404')
  }
  // 计数统计，不然会无限跳转
  if (count > 1) {
    count = 0
    return next()
  }
  if (path === '/login') {
    return next()
  }
  const one = whiteList.some(item=> item.path.indexOf(path) > -1);
  if (one) {
    return next()
  }
  // if(path.indexOf('header')<0){
   
  // }
  const whiteUrlList = ['user.evatmaster.com']
  if(window.parent!==window.self && document.referrer){
    const domain = document.referrer.split('/')[2]
    if(domain && whiteUrlList.includes(domain)){
     return  next('/404')
    }
    await userStore.getMenuAndCurrentCompany()
  }
  try {
    userStore.setBreadcrumb(to.matched)
   if(userStore.refreshPage){
      next({...to,replace:true})
      userStore.refreshPage=false
   }else{
    if(to.name===undefined && !to.path){//去到无定义的路由/无权限的路由，返回首页
      return next({ path: '/' });
    }
    return next()
   }
    
  }catch(err){
    console.log(err);
    count++
  }
})

export default router
